export const UPDATE_PROFIT_FIELDS = 'UPDATE_PROFIT_FIELDS';

interface UpdateProfitFields {
  type: typeof UPDATE_PROFIT_FIELDS;
  payload: Partial<IProfitFields>;
}

export type ProfitActionTypes = UpdateProfitFields;